import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { SmartForm, SmartFormSubmitOptions } from './smart-form';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SmartFormService {
  private static readonly TESTING_PREFIX = 'TESTING DATA';
  private static readonly PREFILL_OVERRIDE_KEY = 'erp.testing.prefill.enabled';

  constructor(
    private fb: FormBuilder,
    private snackBar: MatSnackBar
  ) {}

  control(
    value: any,
    validators: ValidatorFn | ValidatorFn[] | null = null,
    options: {
      asyncValidators?: AsyncValidatorFn | AsyncValidatorFn[] | null;
      updateOn?: 'change' | 'blur' | 'submit';
    } = {}
  ): FormControl {
    return new FormControl(value, {
      validators,
      asyncValidators: options.asyncValidators ?? null,
      updateOn: options.updateOn ?? 'change',
    });
  }

  create<T>(
    controls: any,
    submitHandler: (value: T) => Observable<any>,
    onSuccess?: (res: any) => void,
    onError?: (err: any) => void,
    submitOptions?: SmartFormSubmitOptions
  ): SmartForm<T> {

    const form = this.createFormGroup(controls);


    return new SmartForm<T>(
      form,
      this.snackBar,
      submitHandler,
      onSuccess,
      onError,
      submitOptions
    );

  }

  /**
   * Angular warns when a FormGroup is constructed with dotted keys even though
   * direct controls with those keys are supported. Settings use canonical
   * three-part keys (for example `sales.pricing.default_pricelist`) as their
   * persisted contract, so register those controls after construction instead
   * of changing the keys or nesting the settings payload.
   */
  private createFormGroup(controls: Record<string, unknown>): FormGroup {
    const entries = Object.entries(controls);
    if (!entries.some(([key]) => key.includes('.'))) {
      return this.fb.group(controls);
    }

    const form = this.fb.group({});
    for (const [key, config] of entries) {
      const holder = this.fb.group({ value: config });
      form.addControl(key, holder.controls['value'], { emitEvent: false });
    }
    form.updateValueAndValidity({ emitEvent: false });
    return form;
  }



}
